import { Link } from '@remix-run/react';
import { Image } from '@rocco/components/image';
import type { ImageModel } from '@rocco/types/image-model';

export interface DetailsPageIslandImageProps {
    image: ImageModel;
    background?: string | null;
    link?: string;
    size?: 'full' | 'professionalLogo';
}

export const DetailsPageIslandImage = (props: DetailsPageIslandImageProps) => {
    const { image, background, link, size = 'full' } = props;

    const imageElement = (
        <Image
            src={image.src}
            alt={image.alt ?? 'Logo'}
            size={size}
            fit={
                image.multiplied || size === 'professionalLogo'
                    ? 'contain'
                    : 'cover'
            }
            rounded="full"
        />
    );

    return (
        <div
            className="flex size-18 shrink-0 items-center justify-center overflow-hidden rounded-full"
            style={{
                backgroundColor: background || 'white',
            }}
        >
            {link ? (
                <Link to={link} className="flex items-center justify-center">
                    {imageElement}
                </Link>
            ) : (
                <div className="flex items-center justify-center">
                    {imageElement}
                </div>
            )}
        </div>
    );
};
